import { AxiosResponse } from 'axios';

import { getRbTemplateviewContentByRail } from 'config/api';

import {
    RBBottomTabMenuItem,
    RBParsedRail,
    RBRail,
} from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

export type Params = {
    templateId: RBBottomTabMenuItem['id'];
    rail: RBParsedRail;
    limit: number;
    page: number;
};

async function getCollectionData({
    templateId,
    rail,
    limit,
    page,
}: Params): Promise<RBRail> {
    try {
        const { data }: AxiosResponse<RBRail> = await NagraInstance.get(
            getRbTemplateviewContentByRail(templateId, rail.id, {
                limit,
                page,
            }),
        );

        return data;
    } catch (error: any) {
        return rail as unknown as RBRail;
    }
}

export default getCollectionData;
